"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alternativePhone = void 0;
exports["default"] = phone;

var _get = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PHONE_REGEX = /[a-zA-Z!@#$%^&*_=]/;
var FIRST_CHAR_REGEX = /[0-9]/;
var WHITESPACE_REGEX = /\s/g; // Function to validate phone number;

function phone(value, allValues) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isAlternative = config.isAlternative;
  var rawNumber = value;
  var telephoneCodeKey = isAlternative ? 'alternativePhoneCode' : 'telephoneCode';
  var telephoneCode = (0, _get["default"])(allValues, telephoneCodeKey); // Empty input value is allowed, return no error.

  if (rawNumber === undefined || rawNumber === null || rawNumber === '') {
    return null;
  } // The input holds a value, parse and validate it.


  var cleanRawNumber = !rawNumber || typeof rawNumber !== 'string' ? rawNumber : rawNumber.replace(WHITESPACE_REGEX, ''); // Make sure input value comes in as a string

  if (typeof cleanRawNumber !== 'string') {
    return {
      message: 'validation.invalid.phone'
    };
  } // Must at least contain 7 digits


  var isMinimum = cleanRawNumber.length < 7;

  if (isMinimum) {
    return {
      message: 'validation.invalid.phone'
    };
  } // Character of the string only matches 0-9, +,-


  if (PHONE_REGEX.test(cleanRawNumber)) {
    return {
      message: 'validation.invalid.phone'
    };
  }

  var firstChar = cleanRawNumber.charAt(0); // User doesn't input telephone code and the first character matches 0-9 (Means it's not an international number)

  if (!telephoneCode && FIRST_CHAR_REGEX.test(firstChar)) {
    return {
      message: 'validation.invalid.telephoneCode'
    };
  }

  return null;
} // For alternative phone.


var alternativePhone = exports.alternativePhone = function alternativePhone(value, allValues) {
  return phone(value, allValues, {
    isAlternative: true
  });
};